import { CheckboxState, RecoveryPointType } from './types';

export const handleCheckboxChange = <T extends string | number>(setState: React.Dispatch<React.SetStateAction<CheckboxState<T>>>) =>
  (key: T) => {
    setState((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

export const getCoordinates = (points: RecoveryPointType[]) => {
  const uniqueCoordinates = points.reduce((acc, { coordinates }) => {
    if (!acc.find(([lat, lon]) => lat === coordinates[0] && lon === coordinates[1])) {
      acc.push(coordinates);
    }
    return acc;
  }, []);

  return uniqueCoordinates;
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  };

  const formattedDate = date.toLocaleDateString('fr-FR', options);

  const [weekday, day, month] = formattedDate.split(' ');

  const formattedWeekday = weekday.replace(/^(\w)|\$/g, (match, p1) =>
    p1 ? p1.toUpperCase() : '');

  return `${formattedWeekday} ${day} ${month}`;
};

export const formatDateToDayString = (dateString: string) => {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
  };

  const formattedDate = date.toLocaleDateString('fr-FR', options);

  const [day, month] = formattedDate.split(' ');
  const capitalizedMonth = month.replace(/^\w/, (match) => match.toUpperCase());

  return `${day} ${capitalizedMonth}`;
};

export const formatDateToDayTime = (dateString: string) => {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    hour: 'numeric',
    minute: 'numeric',
  };

  const formattedDate = date.toLocaleDateString('fr-FR', options);

  return ` ${formattedDate}`;
};
